/**
 * Diese Komponente bindet die Module zum Anzeigen und bearbeiten der Help Posts ein.
 */

import 'regenerator-runtime/runtime'
import React, { useCallback, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { HelpPost } from '@professocialApi/professocial-core-frontend-api'
import { Route, Switch } from 'react-router-dom'
import {
  getHelpPostListInitiated,
  deleteEditorHelpPostInitiated,
  createEditorHelpPostInitiated, updateEditorHelpPostInitiated,
} from '../../../store/help/help.actions'
import { helpPostList } from '../../../store/help/help.selector'
import { namedRequestData } from '../../../store/common/common.selectors'
import { CoreRootState } from '../../../store/coreRoot.reducer'
import EditorHelpPostOverview from './EditorHelpComponents/EditorHelpPostOverview'
import EditorHelpPostEditor from './EditorHelpComponents/EditorHelpPostEditor'
import {
  CreateEditorHelpPostRequest,
  DeleteEditorHelpPostRequest, UpdateEditorHelpPostRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/EditorHelpRESTServiceApi'
import Env from '@professocial/professocialLogin/src/config/envConfig'

const BASE_PATH_API = Env.restBase

const EditorHelp: React.FC = () => {
  const dispatch = useDispatch()

  const dispatchGetHelpPostList = useCallback(() => dispatch(getHelpPostListInitiated()), [dispatch])
  const dispatchDeleteEditorHelpPost = useCallback((params: DeleteEditorHelpPostRequest) => dispatch(deleteEditorHelpPostInitiated(params)), [dispatch])
  const dispatchCreateEditorHelpPost = useCallback((params: CreateEditorHelpPostRequest) => dispatch(createEditorHelpPostInitiated(params)), [dispatch])
  const dispatchUpdateEditorHelpPost = useCallback((params: UpdateEditorHelpPostRequest) => dispatch(updateEditorHelpPostInitiated(params)), [dispatch])

  const helpList: HelpPost[] | undefined = useSelector(helpPostList)
  const onDeleteEditorHelpPost = useSelector((state: CoreRootState) => namedRequestData(state, deleteEditorHelpPostInitiated.type))
  const onCreateEditorHelpPost = useSelector((state: CoreRootState) => namedRequestData(state, createEditorHelpPostInitiated.type))
  const onUpdateEditorHelpPost = useSelector((state: CoreRootState) => namedRequestData(state, updateEditorHelpPostInitiated.type))

  useEffect(() => { dispatchGetHelpPostList() }, [])

  const deleteHelpPost = (helpPostId: string) => {
    const params: DeleteEditorHelpPostRequest = {
      helpPostId: helpPostId,
    }
    dispatchDeleteEditorHelpPost(params)
  }

  useEffect(() => {
    if (onDeleteEditorHelpPost?.status === 'success') {
      dispatchGetHelpPostList()
    }
  }, [onDeleteEditorHelpPost, dispatchGetHelpPostList])

  const createHelpPost = (postData: HelpPost) => {
    const params: CreateEditorHelpPostRequest = {
      helpPost: postData,
    }
    dispatchCreateEditorHelpPost(params)
  }

  const updateHelpPost = (postData: HelpPost) => {
    const params: UpdateEditorHelpPostRequest = {
      helpPostId: postData.entityId || '',
      helpPost: postData,
    }
    dispatchUpdateEditorHelpPost(params)
  }

  useEffect(() => {
    if (onCreateEditorHelpPost?.status === 'success') {
      dispatchGetHelpPostList()
    }
  }, [onCreateEditorHelpPost, dispatchGetHelpPostList])

  useEffect(() => {
    if (onUpdateEditorHelpPost?.status === 'success') {
      dispatchGetHelpPostList()
    }
  }, [onUpdateEditorHelpPost, dispatchGetHelpPostList])

  return (
    <Switch>
      <Route exact path='/editor/help/create'>
        <EditorHelpPostEditor createEditorHelpPost={(postData) => createHelpPost(postData)} />
      </Route>
      <Route exact path='/editor/help/edit/:helpPostId'>
        <EditorHelpPostEditor updateEditorHelpPost={(postData) => updateHelpPost(postData)} />
      </Route>
      <Route exact path='/editor/help'>
        <EditorHelpPostOverview
          data={helpList}
          deleteHelpPost={(id) => deleteHelpPost(id)}
          basePath={BASE_PATH_API}
        />
      </Route>
    </Switch>
  )
}
export default EditorHelp
